import {createSlice, PayloadAction} from '@reduxjs/toolkit';


const initialState: ISetStory = {};

export const setStorySlice = createSlice({
  name: 'setStory',
  initialState,
  reducers: {
    addRegisterStoreFormData: (state, action: PayloadAction<ISetStory>) => {
      Object.keys(action.payload).map(
        //@ts-ignore
        item => (state[item] = action.payload[item]),
      );
    },
    // addCertificateLists: (state, action: PayloadAction<string>) => {
    // },

    // resetRegisterAdvertisement: (state, action: PayloadAction<ISetStory>) => {
    // },
  },
});

export const {addRegisterStoreFormData} = setStorySlice.actions;

export default setStorySlice.reducer;
